const MenuTypeEnum = {
    SPLASH_SCREEN: 'splash_screen',
    TWO_OPTION_LARGE: 'two_option_large',
    THREE_OPTION_LARGE: 'three_option_large',
    TWO_TO_SIX_OPTION_FULL_SCREEN: 'two_to_six_option_full_screen',
    TWO_TO_FOUR_OPTION_HALF_SCREEN: 'two_to_four_option_half_screen',
    INFINITE_OPTION: 'infinite_option'
};

const MenuTypeGuiTextEnum = {
    SPLASH_SCREEN: 'Splash Screen',
    TWO_OPTION_LARGE: '2 Option Large',
    THREE_OPTION_LARGE: '3 Option Large',
    TWO_TO_SIX_OPTION_FULL_SCREEN: '2-6 Option Full Screen',
    TWO_TO_FOUR_OPTION_HALF_SCREEN: '2-4 Option Half Screen',
    INFINITE_OPTION: 'Infinite Option'
};

const DefaultMenuTemplates = [
    {
        id: 'default-splash-screen',
        name: 'Splash Screen',
        alias: 'Splash Screen',
        type: 'Menu',
        menuType: MenuTypeEnum.SPLASH_SCREEN,
        titleText: 'Splash Screen Title Goes Here',
        bodyText: 'Splash screen text goes here. There will likely be multiple lines of text at this location. Here is another line of text for demonstration purposes. And one more line of text might go here.',
        backButton: {
            enabled: true,
            timelines: []
        },
        buttons: [
            {text: 'Button Left (optional)', isRequired: false, timelines: []},
            {text: 'Button Center (default)', isRequired: true, timelines: []},
            {text: 'Button Right (optional)', isRequired: false, timelines: []}
        ]
    },
    {
        id: 'default-two-option-large',
        name: '2 Option Large',
        alias: '2 Option Large',
        type: 'Menu',
        menuType: MenuTypeEnum.TWO_OPTION_LARGE,
        titleText: 'Title Goes Here',
        backButton: {
            enabled: true,
            timelines: []
        },
        buttons: [
            {text: 'Button 1', isRequired: true, timelines: []},
            {text: 'Button 2', isRequired: true, timelines: []}
        ]
    },
    {
        id: 'default-three-option-large',
        name: '3 Option Large',
        alias: '3 Option Large',
        type: 'Menu',
        menuType: MenuTypeEnum.THREE_OPTION_LARGE,
        titleText: 'Title Goes Here',
        backButton: {
            enabled: true,
            timelines: []
        },
        buttons: [
            {text: 'Button 1', isRequired: true, timelines: []},
            {text: 'Button 2', isRequired: true, timelines: []},
            {text: 'Button 3', isRequired: true, timelines: []}
        ]
    },
    {
        id: 'default-two-to-six-full-screen',
        name: '2-6 Option Full Screen',
        alias: '2-6 Option Full Screen',
        type: 'Menu',
        menuType: MenuTypeEnum.TWO_TO_SIX_OPTION_FULL_SCREEN,
        titleText: 'Title Goes Here',
        bodyText: '',
        backButton: {
            enabled: true,
            timelines: []
        },
        buttons: [
            {text: 'Button 1 (default)', isRequired: true, timelines: []},
            {text: 'Button 2 (default)', isRequired: true, timelines: []},
            {text: 'Button 3 (optional)', isRequired: false, timelines: []},
            {text: 'Button 4 (optional)', isRequired: false, timelines: []},
            {text: 'Button 5 (optional)', isRequired: false, timelines: []},
            {text: 'Button 6 (optional)', isRequired: false, timelines: []}
        ]
    },
    {
        id: 'default-two-to-four-half-screen',
        name: '2-4 Option Half Screen',
        alias: '2-4 Option Half Screen',
        type: 'Menu',
        menuType: MenuTypeEnum.TWO_TO_FOUR_OPTION_HALF_SCREEN,
        titleText: 'Title Goes Here',
        bodyText: '',
        backButton: {
            enabled: true,
            timelines: []
        },
        buttons: [
            {text: 'Button 1 (default)', isRequired: true, timelines: []},
            {text: 'Button 2 (default)', isRequired: true, timelines: []},
            {text: 'Button 3 (optional)', isRequired: false, timelines: []},
            {text: 'Button 4 (optional)', isRequired: false, timelines: []}
        ]
    },
    {
        id: 'default-infinite-option',
        name: 'Infinite Option',
        alias: 'Infinite Option',
        type: 'Menu',
        menuType: MenuTypeEnum.INFINITE_OPTION,
        titleText: 'Title Goes Here',
        backButton: {
            enabled: true,
            timelines: []
        },
        buttons: [
            {text: 'Button 1', isRequired: false, timelines: []},
            {text: 'Button 2', isRequired: false, timelines: []},
            {text: 'Button 3', isRequired: false, timelines: []},
            {text: 'Button 4', isRequired: false, timelines: []},
            {text: 'Button 5', isRequired: false, timelines: []},
            {text: 'Button 6', isRequired: false, timelines: []},
            {text: 'Button 7', isRequired: false, timelines: []},
            {text: 'Button 8', isRequired: false, timelines: []},
            {text: 'Button 9', isRequired: false, timelines: []},
            {text: 'Button 10', isRequired: false, timelines: []},
            {text: 'Button 11', isRequired: false, timelines: []},
            {text: 'Button 12', isRequired: false, timelines: []},
            {text: 'Button 13', isRequired: false, timelines: []},
            {text: 'Button 14', isRequired: false, timelines: []},
            {text: 'Button 15', isRequired: false, timelines: []}
        ]
    }
]

module.exports = {
    MenuTypeEnum,
    MenuTypeGuiTextEnum,
    DefaultMenuTemplates
};
